




import {Component, Vue} from "vue-property-decorator";
import UserInfo from "@/components/UserInfo.vue";
import {mapMutations} from "vuex";

@Component({
  components: {
    UserInfo,
  },
  methods: {...mapMutations(['setThemeName', 'setIsMenuCompact'])}
})
export default class LayoutObserver extends Vue {
  setThemeName!: (themeType: string) => void;
  setIsMenuCompact!: (isMenuCompact: boolean) => void;

  themeObserver: MutationObserver | null = null;
  menuObserver: MutationObserver | null = null;

  mounted() {
    this.startThemeObserver();
    this.startMenuObserver();
    this.initValues();
  }

  initValues() {
    const themeName = document.documentElement.getAttribute("theme");
    this.setThemeName(themeName || "default");
    const menu = document.getElementsByClassName('RLayoutDashboard__menu');
    menu.length > 0 && this.setIsMenuCompact(menu[0].classList.contains("compact"));
  }

  startThemeObserver() {
    const mutationCallback = (mutationsList: MutationRecord[]) => {
      for (const mutation of mutationsList) {
        if ( mutation.type !== "attributes"
            || mutation.attributeName !== "theme" )
          return

        const themeName = (mutation.target as Element).getAttribute("theme");
        this.setThemeName(themeName || "default");
      }
    }
    this.themeObserver = new MutationObserver(mutationCallback);
    this.themeObserver.observe(document.documentElement, { attributes: true });
  }

  startMenuObserver() {
    const mutationCallback = (mutationsList: MutationRecord[]) => {
      for (const mutation of mutationsList) {
        if ( mutation.type !== "attributes"
            || mutation.attributeName !== "class" )
          return

        const isMenuCompact = (mutation.target as Element).classList.contains("compact");
        this.setIsMenuCompact(isMenuCompact);
      }
    }
    this.menuObserver = new MutationObserver(mutationCallback);
    const menu = document.getElementsByClassName('RLayoutDashboard__menu');
    menu.length > 0 && this.menuObserver.observe(menu[0], { attributes: true, attributeFilter: ['class'] });
  }

  beforeDestroy() {
    this.menuObserver?.disconnect();
    this.themeObserver?.disconnect();
  }
}
